import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { useSeo } from "@/lib/useSeo";

export default function NotFound() {
  useSeo({
    title: "Pagina non trovata — SuiteCrowd",
    description: "La pagina richiesta non esiste o è stata rimossa.",
  });
  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center space-y-8">
        <Logo variant="dark" size="lg" />
        <div className="sc-overline">404</div>
        <h1 className="font-display font-light text-4xl" style={{ letterSpacing: "-0.02em" }}>
          Pagina non trovata
        </h1>
        <p className="text-sm text-neutral-500 leading-relaxed">
          La pagina che stavi cercando non esiste, oppure è stata spostata.
        </p>
        <Link to="/" className="sc-btn-primary inline-flex" data-testid="notfound-home-btn">
          Torna alla home
        </Link>
      </div>
    </div>
  );
}
